import { useState, useEffect } from "react";
import pluralize from "pluralize";
import { AI_TOOL_NAMES } from "../constants";

const useFormText = (
  toolName,
  locked,
  quotaRemaining,
  collapsed,
  isLessThanSmallBreakpoint,
  resetDate,
  infiniteAnswers,
  inContent = false
) => {
  const [buttonText, setButtonText] = useState("");
  const [resetText, setResetText] = useState("");
  const [submittingButtonText, setsubmittingButtonText] = useState("");

  let buttonRemainingText = "";
  let buttonCTA = "";

  useEffect(() => {
    switch (toolName) {
      case AI_TOOL_NAMES.QUIZ_QUESTIONS:
      case AI_TOOL_NAMES.DISCUSSION_QUESTIONS:
        buttonRemainingText =
          !locked && !infiniteAnswers && quotaRemaining > 0 && !inContent
            ? ` (${pluralize("use", quotaRemaining, true)} left)`
            : "";
        buttonCTA = inContent ? "Generate" : "Generate Questions";
        if (quotaRemaining > 0 && !collapsed && isLessThanSmallBreakpoint) {
          buttonCTA = "Submit";
        }
        setResetText(
          `${pluralize(
            "use",
            quotaRemaining,
            true
          )} of this tool left (resets on ${resetDate})`
        );
        setsubmittingButtonText("Generating...");

        break;
      case AI_TOOL_NAMES.ESSAY_PROMPTS:
        buttonRemainingText =
          !locked && !infiniteAnswers && quotaRemaining > 0
            ? ` (${pluralize("use", quotaRemaining, true)} left)`
            : "";
        buttonCTA = "Generate Prompts";
        if (quotaRemaining > 0 && !collapsed && isLessThanSmallBreakpoint) {
          buttonCTA = "Submit";
        }
        setResetText(
          `${pluralize(
            "use",
            quotaRemaining,
            true
          )} of this tool left (resets on ${resetDate})`
        );
        setsubmittingButtonText("Generating...");

        break;
      case AI_TOOL_NAMES.ASK_AI:
        buttonRemainingText =
          !locked && !infiniteAnswers && quotaRemaining > 0
            ? ` (${quotaRemaining} left)`
            : "";
        buttonCTA = "Ask LitCharts AI";
        if (quotaRemaining > 0 && !collapsed && isLessThanSmallBreakpoint) {
          buttonCTA = "Submit";
        } else if (quotaRemaining > 0 && quotaRemaining < 25) {
          buttonCTA = "Ask New Question";
        }
        setResetText(
          `${pluralize(
            "answer",
            quotaRemaining,
            true
          )} left (resets on ${resetDate})`
        );
        setsubmittingButtonText("Answering...");
        break;
      default:
        setButtonText("");
        setResetText("");
        return;
    }

    setButtonText(buttonCTA + buttonRemainingText);
  }, [
    toolName,
    locked,
    quotaRemaining,
    collapsed,
    isLessThanSmallBreakpoint,
    resetDate
  ]);

  return { buttonText, resetText, submittingButtonText };
};

export default useFormText;
